export function renderAsync<T, U, TError = Error>(
  loading: boolean,
  error: TError,
  result: T | undefined,
  renderings: {
    loading: () => U;
    error: (err: TError) => U;
    result: (res: T) => U;
    notRequested?: () => U;
  }
): U | null {
  if (loading) {
    return renderings.loading();
  }
  if (error) {
    return renderings.error(error);
  }
  if (result) {
    return renderings.result(result);
  }
  // if we don't handle the not requested case, we should return null
  return renderings.notRequested ? renderings.notRequested() : null;
}
